import { render } from "./DialogAddCompany.vue?vue&type=template&id=e1591790&scoped=true&ts=true"
import script from "./DialogAddCompany.vue?vue&type=script&lang=ts"
export * from "./DialogAddCompany.vue?vue&type=script&lang=ts"

import "./DialogAddCompany.vue?vue&type=style&index=0&id=e1591790&lang=stylus&scoped=true"

import exportComponent from "/Users/yangwenqi/Desktop/蓝豚/web/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1591790"]])

export default __exports__